import React from 'react';
import './Accordions.scss'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export default function Accordions(data) {
  const dataArray = Object.values(data).flat(); 

  return (
    <div className='accordion'>
      {dataArray.map((item, index) => (
        <Accordion key={index}>
          <AccordionSummary
            expandIcon={<ArrowDownwardIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
          >
            <p>{item.question}</p>
          </AccordionSummary>
          <AccordionDetails>
            <p>{item.answer}</p>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
